import React, { useState, useEffect } from 'react';
import { createRoot } from 'react-dom/client';
import { CustomizeProvider } from './contexts/customize';
import 'bootstrap/dist/css/bootstrap.min.css';
import '../assets/theme.css';
import Customize from './pages/customize';
import CustomizeConfirm from './pages/customizeConfirm';
import restoreReorderPayloadFromUrl from './lib/reorderPayload';

restoreReorderPayloadFromUrl();

const Mtm = () => {
  const [displayCustomize, setDisplayCustomize] = useState(true);
  const [popup, setPopup] = useState(false);
  const clickConfirm = () => {
    setDisplayCustomize(false);
  };
  const clickReturnCustomize = () => {
    document.getElementById('mtm-customize').classList.remove('confirm');
    document.getElementById('mtm-timeline').classList.remove('none');
    document.getElementById('mtm-header').classList.remove('none');
    setPopup(false);
    setDisplayCustomize(true);
  };
  useEffect(() => {
    window.scrollTo(0, 0);
  }, [displayCustomize]);
  return (
    <>
      <div className={displayCustomize ? '' : 'd-none'}>
        <Customize onClickConfirm={clickConfirm} />
      </div>
      <div className={displayCustomize ? 'd-none' : ''}>
        <CustomizeConfirm
          onClickReturn={clickReturnCustomize}
          popup={popup}
          setPopup={setPopup}
        />
      </div>
    </>
  );
};
const container = document.getElementById('mtm-customize');
if (container) {
  const root = createRoot(container);
  root.render(
    <CustomizeProvider>
      <Mtm />
    </CustomizeProvider>
  );
}
